<template>
<div class="demo-image__placeholder">

	<div :style="{background: 'url('+ require('@/assets/back.png')+') no-repeat', height:'400px', backgroundSize:'cover', backgroundPosition:'center'}" id="bg">
		<div style="font-size: 40px;padding: 150px 150px;color: white;text-align: left;">
			翻译价格低至0.2元/1500字符
			<div style="background-color: white;border-radius: 45px;width: 200px;text-align: center;margin-top:20px; ">
				<a href='https://helloworlddow.lanzoui.com/s/HelloWorldPro' target="_blank" style="text-decoration:none; color: white;font-size: 20px;color: #236def;vertical-align: middle;">下载helloworld</a>
			</div>
		</div>
	</div>
	<div style="text-align: center;text-align: center;">
		<table class="versionTable" border="0" cellspacing="0" cellpadding="0" id="">
		 <tr>
			 <th>套餐参数</th>
			 <th>基础版 <br> <span style="font-size: 20px;">{{price0}}</span> 元 <br> <el-button type="primary" round @click="goRecharge(0)" id="jichuBtn" size="small">立即购买</el-button></th>
			 <th>高级版 <br> <span style="font-size: 20px;">{{price1}}</span> 元 <br> <el-button type="success" round @click="goRecharge(1)" id="gaojiBtn" size="small">立即购买</el-button></th>
			 <th>旗舰版 <br> <span style="font-size: 20px;">{{price2}}</span> 元 <br> <el-button type="warning" round @click="goRecharge(2)" id="qijianBtn" size="small">立即购买</el-button></th>
		 </tr>
     <tbody>
       <tr>
         <td >端口数量</td>
         <td><span style="color: red;">{{port0}}</span> 个</td>
         <td><span style="color: red;">{{port1}}</span> 个</td>
         <td><span style="color: red;">{{port2}}</span> 个</td>
       </tr>
       <tr style="background-color: #fafafa;">
         <td >自动补录</td>
         <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
         <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
         <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
       <tr>
         <td >数据导出</td>
         <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
         <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
         <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
       <tr style="background-color: #fafafa;">
          <td >主号移出工</td>
          <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
          <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
          <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
       <tr>
        <td >实时统计进粉数</td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
       <tr style="background-color: #fafafa;">
        <td >WA新对话自动回复</td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
       <tr>
        <td >聊天助手</td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
       <tr style="background-color: #fafafa;">
        <td >工单标记粉丝重粉</td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
       <tr>
        <td >主号分配轮切</td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
       <tr style="background-color: #fafafa;">
        <td >WA封号保留聊天记录</td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
       <tr>
        <td >计数器账号标记粉丝重粉</td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
       <tr style="background-color: #fafafa;">
        <td >数据SSL协议加密传输</td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
       <tr>
        <td >AWS云安全加密</td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
       <tr style="background-color: #fafafa;">
        <td >客服一对一辅导</td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
       <tr>
        <td >问题反馈</td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
        <td><el-button type="success" icon="el-icon-check" circle size="mini"></el-button></td>
       </tr>
     </tbody>
	</table>
	</div>
</div>
</template>

<script>
  export default {
    data() {
      return {
		version: [],
		port0:'',
		port1:'',
		port2:'',
		price0:'',
		price1:'',
		price2:'',
		url: require("@/assets/use.jpg"),
		srcList: [
		  require("@/assets/step1.png"),
		  require("@/assets/step2.png"),
		  require("@/assets/step3.png"),
		  require("@/assets/step4.png"),
		  require("@/assets/step5.png"),
		  require("@/assets/step6.png")
		]
      };
    },
    mounted: function () {
		this.getVersion();
    },
    methods: {
		goRecharge(type){
			this.$router.push({path:'/user/rechargePage', query: {type: type}});
		},
		changeImg(value){
			this.port = this.version[value].port;
		},
	    getVersion(){
			this.postRequest("/userVersion/getVersion",{}).then(resp=> {
			if (resp && resp.status == 200) {
				var data = resp.data;
				this.version = data;
				this.port0 = data[0].port;
				this.port1 = data[1].port;
				this.port2 = data[2].port;

				this.price0 = data[0].price;
				this.price1 = data[1].price;
				this.price2 = data[2].price;
			  }
			})
	   },
    }
  };
</script>

<style>
  @media screen  and (max-width: 500px){
    #bg{
        display: none;
    }
  }


  .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .slide-fade-enter-active {
    transition: all .8s ease;
  }

  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

  .el-menu-item *{
	  vertical-align:baseline;
  }

  .versionTable{
	  margin: 0 auto;
	  width:90%;
	  height:700px;

  }

  .tdTop{
	  vertical-align: top;
  }

  .versionTable td{
	  padding-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomeIndex.vue